import { render, staticRenderFns } from "./CellRendererPriority.vue?vue&type=template&id=0ba28f9c"
import script from "./CellRendererPriority.vue?vue&type=script&lang=js"
export * from "./CellRendererPriority.vue?vue&type=script&lang=js"
import style0 from "./CellRendererPriority.vue?vue&type=style&index=0&id=0ba28f9c&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports